import React, { useState, useEffect, useRef } from 'react'
import {
  Button,
  ContextMenu,
  IListItem,
} from '@doseme/cohesive-ui'

import { authContext, getToken } from '../../adalConfig'
import { parseJwt } from '../../utils/jwt'
import './index.scss'

const NavMenu: React.FC = () => {
  const [showMenu, toggleMenu] = useState(false)
  const [fullName, setFullName] = useState('Admin Dashboard')

  const navbarContextMenuRef = useRef<HTMLElement>(null)
  const navbarCircleButtonRef = useRef<HTMLDivElement>(null)

  const handleClickOut = (e: MouseEvent): void => {
    // We need to cast the MouseEvent as a React node to detect it in the ref. TypeScript is so hacky sometimes lol
    if (navbarContextMenuRef.current?.contains(e.target as HTMLElement)  // Ignore click inside menu
      || navbarCircleButtonRef.current?.contains(e.target as HTMLElement)) {  // and show btn to avoid toggle conflict
      return
    }

    toggleMenu(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOut)
    return () => {
      document.removeEventListener('mousedown', handleClickOut)
    }
  }, [])

  useEffect(() => {
    getToken().then(jwt => {
      if (!jwt) {
        return
      }

      // default to AD, just in case something goes wrong.
      const { family_name = 'Admin', given_name = 'Dashboard' } = parseJwt(jwt)
      setFullName(`${given_name} ${family_name}`)
    })
  }, [])

  const items: IListItem[] = [
    {
      id: 2,
      icon: <span />,
      text: 'Log Out',
      onClick: () => authContext.logOut()
    }
  ]

  const [given, family] = fullName.split(' ')
  const initials = given[0] + family[0]

  const contextMenu = showMenu && (
    <span ref={navbarContextMenuRef} id='navbar-context-menu'>
      <ContextMenu
        header={fullName}
        items={items}
      />
    </span>
  )

  return (
    <span id='navbar-menu-wrapper'>
      <div ref={navbarCircleButtonRef}>
        <Button
          onClick={() => toggleMenu(!showMenu)}
          variant='primary'
          shape='circle'
        >
          {initials}
        </Button>
      </div>
      {contextMenu}
    </span>
  )
}

export {
  NavMenu,
}
